import redirectOther from '@/components/Redirect/redirectOther';

const Redirect = () => redirectOther('/clases');

export default Redirect;
